/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable object-curly-newline */
import React from 'react';
import { PieChart, Pie, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import Panel from '../../../shared/components/Panel';
import { getPercentage } from '../../../shared/utils';

const propTypes = {
  body: PropTypes.object.isRequired,
};

const tooltipPropTypes = {
  active: PropTypes.bool.isRequired,
  payload: PropTypes.array.isRequired,
};

const vehiclesNum = (vehicleType) => vehicleType || 0;

const QuotationsStatisticsComponet = (props) => {
  const { body } = props;

  const tipo = [
    { name: 'Automóvil', value: body.types ? body.types.auto : 0, fill: '#4ce1b6' },
    { name: 'Motocicleta', value: body.types ? body.types.moto : 0, fill: '#70bbfd' },
    { name: 'Camión', value: body?.types?.camion || 0, fill: '#f6da6e' },
    { name: 'Bus - Minibus', value: body?.types?.bus || 0, fill: '#ff73a6' },
  ];

  const estado = [
    { name: 'Abierto', value: body.status ? body.status.opened : 0, fill: '#4ce1b6' },
    { name: 'Cerrado', value: body.status ? body.status.closed : 0, fill: '#70bbfd' },
    { name: 'Pendiente', value: body.status ? body.status.pending : 0, fill: '#ff4861' },
  ];

  const origen = [
    { name: 'Presencial', value: body.origins ? body.origins.face : 0, fill: '#4ce1b6' },
    { name: 'Referido', value: body.origins ? body.origins.referred : 0, fill: '#70bbfd' },
    { name: 'Teléfono', value: body.origins ? body.origins.phone : 0, fill: '#f6da6e' },
    { name: 'Web', value: body.origins ? body.origins.web : 0, fill: '#d959d2' },
    { name: 'Spider', value: body.origins ? (body.origins.spider ? body.origins.spider : 0) : 0, fill: '#000000' },
  ];

  const evaluation = [
    { name: 'Aprobado', value: body.evaluationStatus ? body.evaluationStatus.Aprobado : 0, fill: '#4ce1b6' },
    { name: 'Rechazado', value: body.evaluationStatus ? body.evaluationStatus.Rechazado : 0, fill: '#ff4861' },
  ];

  const trinidad = [
    { name: 'Aprobado', value: body.trinidadStatus ? body.trinidadStatus.Aprobado : 0, fill: '#4ce1b6' },
    { name: 'Precursado', value: body.trinidadStatus ? body.trinidadStatus.Precursado : 0, fill: '#70bbfd' },
    { name: 'Cursado', value: body.trinidadStatus ? body.trinidadStatus.Cursado : 0, fill: '#f6da6e' },
    { name: 'Rechazado', value: body.trinidadStatus ? body.trinidadStatus.Rechazado : 0, fill: '#ff4861' },
  ];

  const style = {
    left: 0,
    width: 150,
    lineHeight: '24px',
    position: 'relative',
  };

  const renderLegend = ({ payload }) => (
    <ul className="dashboard__chart-legend">
      {payload.map((entry, index) => (
        <li key={`item-${index}`}>
          <span style={{ backgroundColor: entry.color }} />
          {entry.value}: {entry.payload.value} ({getPercentage(entry.payload.value, body.total)}%)
        </li>
      ))}
    </ul>
  );

  renderLegend.propTypes = {
    payload: PropTypes.arrayOf(PropTypes.shape({
      color: PropTypes.string,
      value: PropTypes.string,
    })).isRequired,
  };

  const renderTooltip = ({ active, payload }) => {
    if (active) {
      return (
        <div className="recharts-custom-tooltip">
          <p className="label">{`${payload[0].name}: ${payload[0].value} (${getPercentage(payload[0].value, body.total)}%)`}</p>
        </div>
      );
    }
    return null;
  };
  renderTooltip.propTypes = tooltipPropTypes;

  return (
    <div className="section-content row">

      <Panel lg={6} md={6} xl={3} title="ESTADO" subhead="Total">
        <div className="dashboard__visitors-chart">
          <h1 className="dashboard__visitors-chart-title">{body.status ? (body.status.closed + body.status.opened + body.status.pending) : 0}</h1>
          <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
            <PieChart className="dashboard__chart-pie-container">
              <Tooltip content={renderTooltip} />
              <Pie data={estado} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
              <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Panel>

      <Panel lg={6} md={6} xl={3} title="ORIGEN" subhead="Total">
        <div className="dashboard__visitors-chart">
          <h1 className="dashboard__visitors-chart-title">{body.origins ? (body.origins.face + body.origins.referred + body.origins.phone + body.origins.web + body.origins.trinidad + (body.origins.spider ? body.origins.spider : 0)) : 0}</h1>
          <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
            <PieChart className="dashboard__chart-pie-container">
              <Tooltip content={renderTooltip} />
              <Pie data={origen} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
              <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Panel>

      <Panel lg={6} md={6} xl={3} title="TIPOS" subhead="Total">
        <div className="dashboard__visitors-chart">
          <h1 className="dashboard__visitors-chart-title">{vehiclesNum(body?.types?.auto) + vehiclesNum(body?.types?.moto) + vehiclesNum(body?.types?.camion) + vehiclesNum(body?.types?.bus)}</h1>
          <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
            <PieChart className="dashboard__chart-pie-container">
              <Tooltip content={renderTooltip} />
              <Pie data={tipo} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
              <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Panel>

      <Panel lg={6} md={6} xl={3} title="EVALUACIÓN" subhead="Total">
        <div className="dashboard__visitors-chart">
          <h1 className="dashboard__visitors-chart-title">{body.evaluationStatus ? (body.evaluationStatus.Aprobado + body.evaluationStatus.Rechazado) : 0}</h1>
          <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
            <PieChart className="dashboard__chart-pie-container">
              <Tooltip content={renderTooltip} />
              <Pie data={evaluation} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
              <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Panel>

      <Panel lg={6} md={6} xl={3} title="TRINIDAD" subhead="Total">
        <div className="dashboard__visitors-chart">
          <h1 className="dashboard__visitors-chart-title">{body.trinidadStatus ? (body.trinidadStatus.Aprobado + body.trinidadStatus.Cursado + body.trinidadStatus.Precursado + body.trinidadStatus.Rechazado) : 0}</h1>
          <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={220}>
            <PieChart className="dashboard__chart-pie-container">
              <Tooltip content={renderTooltip} />
              <Pie data={trinidad} dataKey="value" cy={110} cx={95} innerRadius={70} outerRadius={100} />
              <Legend layout="vertical" verticalAlign="bottom" wrapperStyle={style} content={renderLegend} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Panel>

    </div>
  );
};

QuotationsStatisticsComponet.propTypes = propTypes;

export default QuotationsStatisticsComponet;
